import { CardExpFormatter } from './CardExpFormatter';
import { CardNumFormatter } from './CardNumFormatter';
import { PhoneNumFormatter } from './PhoneNumFormatter';

export default {
    cardExp: {
        class: CardExpFormatter,
        instances: {}
    },
    cardNum: {
        class: CardNumFormatter,
        instances: {}
    },
    phoneNum: {
        class: PhoneNumFormatter,
        instances: {}
    }
};